

export default class WarningAlertKoComponent {}
